import {SHOW_MODAL} from "../types";

const modalShow= (data) => {
  return ({type: SHOW_MODAL, payload: data});
};
export default modalShow;